import { HHNTheme } from "hhn-commons";

interface PendingReferralIconProps {
  size?: number;
}

function PendingReferralIcon({ size = 24 }: PendingReferralIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
    >
      <path
        fill={HHNTheme.error}
        d="m11.385 15.277-9.75 8.528a2.55 2.55 0 0 0 .99.195h18.75a2.55 2.55 0 0 0 .982-.195l-9.75-8.535a.937.937 0 0 0-1.222.007Z"
      />
      <path
        fill={HHNTheme.error}
        d="M23.017 8 13.807.637a2.88 2.88 0 0 0-3.615 0L.982 8a2.6 2.6 0 0 0-.93 1.57 2.542 2.542 0 0 0-.052.48v11.325A2.632 2.632 0 0 0 .27 22.5l7.93-6.945L1.875 10.5v-.45a.75.75 0 0 1 .285-.585l9.2-7.365a1.012 1.012 0 0 1 1.275 0l9.2 7.365a.75.75 0 0 1 .285.585v.45l-6.33 5.07 7.94 6.93a2.632 2.632 0 0 0 .27-1.125V10.05a2.542 2.542 0 0 0-.053-.48 2.6 2.6 0 0 0-.93-1.57Z"
      />
    </svg>
  );
}

export default PendingReferralIcon;
